import { Component, OnInit } from '@angular/core';
import { FormularioComponent } from './components/formulario/formulario.component';



@Component({
    selector: 'lib-cadastrar-contratante-gerenciadas',
    templateUrl: 'cadastrar-contratante.component.html',
    styleUrls: ['cadastrar-contratante.component.scss'],
})

export class CadastrarContratanteComponent implements OnInit {



    constructor() { }

    ngOnInit() {

    }


    getResultado($event) {

        console.log("borao Clicado!");

    }
}